
import React, { Component } from 'react'; 
import {Tabs, Tab} from 'react-bootstrap';
import SamplingElements from './SamplingElements'
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {AuditTypeList} from '../DynamicForm/FormAction';
import {SamplingDurationAction, SamplingTemplateAction,SamplingTemplateReAssign, SamplingTemplateMapping, SamplingTemplateAdd, SamplingTemplateUpdateMapping, SamplingTemplateEdit, SamplingMappedListAction, SamplingDefaultTemplate, closeModalPopUp} from './SamplingAction'
import {InventoryMaster} from '../Inventory/InventoryAction';
import SamplingMapping from './SamplingMapping.js';
import MappedList from './MappedList.js'
import _ from 'lodash';
import ShowModalPopUp from '../ShowModalPopUp';

 class Samplingindex extends Component {
   constructor(props){
     super(props)
     this.state={
     }
   }
  componentWillMount(){
    this.props.TokenValidation()  
    this.props.defaultTemplate()
    this.props.samplingDuration()
    this.props.AuditTypeList()
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  }
  ScreensComp = () =>{        
    const{inventoryMapped, duration, templates, masterinventory, mappedData, mapstatus, mapmessage, loginAction, auditTypes} = this.props;  
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "SAMPLING"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "MAPPED_LIST"){ 
          returnObj.push(<Tab eventKey="MAPPED_LIST" title="MAPPED LIST" key={3}>          
           <MappedList 
           action={this.props} 
           accessPermission={obj.accessPermission}
           templates={templates}
           durationProp={duration} 
           auditTypes={auditTypes}
           mappedData={mappedData}/> 
          </Tab>)}
        if(obj.screenUId === "SAMPLING_LOGIC"){ 
          returnObj.push(<Tab eventKey="SAMPLING_LOGIC" title="DEFINE CRITERIA" key={1}>
              <SamplingElements action={this.props} accessPermission={obj.accessPermission}
              masterinventory= {masterinventory} templates={templates} defaultTemplate={this.props.default} auditTypes={auditTypes}
              durationProp={duration} /> 
          </Tab>)}
				if(obj.screenUId === "SAMPLING_MAPPING"){ 
          returnObj.push(<Tab eventKey="SAMPLING_MAPPING" title="TEMPLATE MAPPING" key={2}>
           <SamplingMapping inventory={inventoryMapped} action={this.props}
            mapstatus={mapstatus}  mapmessage={mapmessage} 
            templates={templates}/> 
        </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 
  render(){
     let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}
    return(
     <div className={(style) ? 'user' : "userSmall"}>
       {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.ScreensComp()}
     </div>
    )
  }
}
function mapStateToProps(state){
  return{
   inventoryMapped: state.UserReducer.inventoryMapped,
   agentCategory:state.InventoryReducer.categories,
   templates : state.SamplingReducer.sampling,  
   duration: state.SamplingReducer.duration,  
   mappedData: state.SamplingReducer.mappedData,
   default: state.SamplingReducer.default,
   mapstatus: state.SamplingReducer.mapstatus,
   mapmessage: state.SamplingReducer.mapmessage,
   size: state.UserReducer.large,
   showerror:  state.SamplingReducer.showerror, 
   errmessage:  state.SamplingReducer.errmessage,   
   loginAction: state.LoginReducer.loginAction,
   showModalLogin: state.UserReducer.showModalLogin,
   auditTypes: state.FormReducer.auditTypes,
   masterinventory: state.InventoryReducer.master
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  actioninventoryMaster: () => dispatch(InventoryMaster()),  
  SampleTemplate:  () =>dispatch(SamplingTemplateAction()),  
  addTemplate: (a) =>dispatch(SamplingTemplateAdd(a)),
  editTemplate:(a, b) =>dispatch(SamplingTemplateEdit(a, b)),
  mapSamplingTemplate: (a) => dispatch(SamplingTemplateMapping(a)),
  mapSamplingTemplateUpdate: () => dispatch(SamplingTemplateUpdateMapping()),
  samplingDuration: () => dispatch(SamplingDurationAction()),
  defaultTemplate: () =>dispatch(SamplingDefaultTemplate()),
  mappingAction:  () =>dispatch(SamplingMappedListAction()),
  closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)),
  TokenValidation : (a) => dispatch(TokenValidation(a)),
  SamplingTemplateReAssign: (a) => dispatch(SamplingTemplateReAssign(a)),
  AuditTypeList: () => dispatch(AuditTypeList())
})

export default connect(mapStateToProps, mapDispatchToProps)(Samplingindex);